/* React 19 - Using createRoot API */
import React from 'react';
import 'typeface-open-sans';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import { MantineProvider } from '@mantine/core';
import configureStore from './store/configureStore';
import App from './App';
import './App.css';
import './utils/firebase';
import { SessionExpiredHelper } from './contexts/sessionExpiredHelper';
import { SessionExpiredProvider } from './contexts/SessionExpiredContext';
import { subsidiTheme } from './utils/theme/theme';

const store = configureStore();
const customHistory = createBrowserHistory({ basename: '/dc' });

// Boot app only outside test environment
if (process.env.NODE_ENV !== 'test') {
  const { createRoot } = require('react-dom/client');
  const container = document.getElementById('app');
  if (container) {
    const root = createRoot(container);
    root.render(
      <Provider store={store}>
        <MantineProvider theme={subsidiTheme}>
          <SessionExpiredProvider>
            <SessionExpiredHelper />
            <App history={customHistory} store={store} />
          </SessionExpiredProvider>
        </MantineProvider>
      </Provider>
    );
  }
}

/* Hot Module Replacement for React 19 (using Fast Refresh) */
if (module.hot) {
  module.hot.accept('./App', () => {
    // No need to manually re-render with Fast Refresh
    // React Fast Refresh handles this automatically
  });
}

/* Test helper to support legacy hot accept testing */
export function moduleHotAccept({ hot }) {
  const { render } = require('react-dom');
  // Call render once immediately
  render(null);
  // Trigger the provided hot accept callback, which will call render again
  if (hot && typeof hot.accept === 'function') {
    hot.accept('./App', () => {
      const { render: rerender } = require('react-dom');
      rerender(null);
    });
  }
}
